<template>
  <div class="share">
    <div hidden>
      <vue-canvas-poster :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!-- <div class="flex-column "> -->
    <div class="swiper-num">{{ activeIndex + 1 }}/{{ list.length }}</div>
    <div class="swiper-content">
      <swiper ref="mySwiper" :options="swiperOption" class="show-swiper">
        <template v-for="(item, index) in list">
          <swiper-slide :key="index">
            <div class="swiper-item">
              <img class="share2-bg" :src="item.img" />
              <div v-if="user" class="share2-bg share2-content">
                <div class="share2-header flex-row">
                  <img
                    v-if="user.avatar && user.avatar != 0"
                    class="share2-header-icon"
                    :src="user.avatar"
                  />
                  <img v-else class="share2-header-icon" src="../../static/images/logo.jpg" />
                  <span>{{user.nickname}}</span>
                </div>
                <div class="share2-vowtext">{{urlData.vowtext}}</div>
                <div v-if="urlData.place" class="share2-place flex-row">
                  <img class="share2-place-icon" src="../../static/images/location_icon@2x.png" />
                  <div class="share2-place-content">
                    我在
                    <span>{{urlData.place}}</span> 祈福
                  </div>
                </div>
              </div>
              <div class="share-num">
                已有
                <span>{{wishTotal}}</span> 人为武汉祈福
              </div>
              <div class="share2-ercode-wrap">
                <img class="share2-ercode" :src="share_qrcode" />
                <img
                  v-if="user && user.avatar && user.avatar != 0"
                  class="share2-headimg"
                  :src="user.avatar"
                />
                <img v-else class="share2-headimg" src="../../static/images/logo.jpg" />
              </div>
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
    <div class="swiper-desc">{{_getBrowser() == 1 ? '生成海报后，可长按进行保存/分享':'左右滑动可切换图片模板'}}</div>
    <div class="share-btn" @click="goPoster"></div>
    <!-- </div> -->
  </div>
</template>
<script>
import Vue from "vue";
import Share from "../components/Share.vue";
// import SharePrize from "../components/SharePrize.vue";
Vue.use(Share);

import CanvasPoster from "vue-canvas-poster";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import config from "../config.js";

export default {
  name: "ShareIndex",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    var t = this;
    return {
      activeIndex: 0,
      user: null,
      imgsrc: "",
      urlData: null,
      share_qrcode: "",
      list: [
        { img: require("../../static/images/poster1.jpg") },
        { img: require("../../static/images/poster2.jpg") },
        { img: require("../../static/images/poster3.jpg") },
        { img: require("../../static/images/poster4.jpg") },
        { img: require("../../static/images/poster5.jpg") }
      ],
      painting: {},
      swiperOption: {
        slidesPerView: "auto",
        watchSlidesProgress: true,
        // 设定slide与左边框的预设偏移量（单位px）
        slidesOffsetBefore: 0,
        // 设置slide之间的距离（单位px）
        spaceBetween: 0,
        centeredSlides: true,
        init: false,
        on: {
          progress: function() {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i);
              const slideProgress = this.slides[i].progress;

              const scale = 1 - Math.abs(slideProgress) / 9; // 缩放权重值，随着progress由中向两边依次递减，可自行调整
              slide.transform(`scale3d(${scale}, ${scale}, 1)`);
            }
          },
          slideChange: function() {
            t.activeIndex = this.activeIndex;
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    var t = this;
    var q = t.$route.query;
    if (q.vowtext) {
      q.vowtext = decodeURIComponent(q.vowtext);
      t.urlData = q;
    }
    var code_url = `${t._getInitUrl().roothref}index.html#/?a=${
      t._getAPPParams().activity_id
    }&channel=${t._getBrowser() == 1 ? "jegotripapp" : "wechat"}`;
    t.share_qrcode = t.$qrcode.getQrBase64(code_url);
  },
  mounted() {
    this.initSwiper();
    // this.addPosterId();
    this.getMyUser();
  },
  methods: {
    //app预览海报
    previewImg() {
      var t = this;
      try {
        Jegotrip.articlePictureShareResp(this.imgsrc);
        this._deepmain(this.pageId, "poster#posterpic", 2);
      } catch (e) {
        t.$router.push({
          path: "/poster",
          query: {
            vowtext: encodeURIComponent(t.urlData.vowtext),
            place: t.urlData.place,
            postid: t.activeIndex + 1
          }
        });
      }
    },
    //海报生成成功回调
    success(src) {
      var t = this;
      t.imgsrc = src;
      if (t._getBrowser() == 1) {
        t.previewImg();
      } else {
        t.$router.push({
          path: "/poster",
          query: {
            vowtext: encodeURIComponent(t.urlData.vowtext),
            place: t.urlData.place,
            postid: t.activeIndex + 1,
            mypost: encodeURIComponent(src)
          }
        });
      }
    },
    //海报生成失败回调
    fail(err) {
      var t = this;
      console.log(err);
      t.$dialog
        .alert({
          title: "操作提示",
          message: "您的头像已过期，请在返回“我的”页面更换后重试",
          confirmButtonText: "刷新页面"
        })
        .then(() => {
          localStorage.removeItem(config.login_key);
          window.location.reload();
        });
      return;
      t.$router.push({
        path: "/poster",
        query: {
          vowtext: encodeURIComponent(t.urlData.vowtext),
          place: t.urlData.place,
          postid: t.activeIndex + 1
        }
      });
    },
    //获取用户基本信息
    async getBaseUser() {
      var t = this;
      var userid = 0;
      var app_login_user = localStorage.getItem(config.login_key);
      if (app_login_user) app_login_user = JSON.parse(app_login_user);
      if (app_login_user.userid) {
        userid = app_login_user.userid;
      }
      var code_url = `${t._getInitUrl().roothref}index.html#/?a=${
        t._getAPPParams().activity_id
      }&channel=${t._getBrowser() == 1 ? "jegotripapp" : "wechat"}`;
      console.warn(code_url);
      t.url = code_url; //二维码链接地址
      t.vowText = t.params.vowtext; //愿望文本
      t.place = t.params.place; //地址
      t.zCount = t.params.zCount; //祈福人数
      t.avatar = require("../../static/images/logo.jpg"); //默认头像
      t.nickname = ""; //默认昵称
      t.vowImg = require("../../static/images/poster" +
        t.params.postid +
        ".jpg"); //海报背景
      t.addIcon = require("../../static/images/location_icon@2x.png"); //定位图标
      //
      // t.vowText = "计算愿望长度，中文两个字符占位";
      var Vlen = 0; //计算愿望长度，中文两个字符占位，英文数字一个字符占位
      for (var i = 0; i < t.vowText.length; i++) {
        if ((t.vowText.charCodeAt(i) & 0xff00) != 0) {
          Vlen++;
        }
        if (/[il]+/.test(t.vowText[i])) Vlen -= 0.45;
        if (/[w]+/gi.test(t.vowText[i])) Vlen += 0.45;
        Vlen++;
      }
      t.place = "      " + t.place;
      var Plen = 0; //计算地址长度，中文两个字符占位，英文数字一个字符占位
      var PPlen = 0;
      for (var i = 0; i < t.place.length; i++) {
        if ((t.place.charCodeAt(i) & 0xff00) != 0) {
          Plen++;
        }
        if (/[il]+/.test(t.place[i])) Plen -= 0.45;
        if (/[w]+/gi.test(t.place[i])) Plen += 0.45;
        if (t.place[i] == " ") PPlen += 1;
        Plen++;
      }
      console.log("vlen", Vlen);
      console.log("Plen", Plen);
      if (t.user) {
        var myuser = t.user;
        if (myuser.avatar && myuser.avatar != 0) {
          t.avatar = myuser.avatar.replace("http", "https");
          // t.avatar = t._getBrowser() == 2 ? myuser.avatar.replace("http", "https") : myuser.avatar;
        }
        if (myuser.nickname) t.nickname = myuser.nickname;
      } else {
        var params = {
          rec_uid: t._getAPPParams().share_userid,
          activity_id: t._getAPPParams().activity_id
        };
        await t._signup("user", "User.getUserInfo", params).then(res => {
          if (res.status == 0) {
            var myuser = res.data.user;
            if (myuser.avatar && myuser.avatar != 0) {
              t.avatar = myuser.avatar.replace("http", "https");
              // t.avatar = t._getBrowser() == 2 ? myuser.avatar.replace("http", "https") : myuser.avatar;
            }
            if (myuser.nickname) t.nickname = myuser.nickname;
          }
        });
      }

      var painting_view = [];
      //背景图
      painting_view.push({
        type: "image",
        url: t.vowImg,
        left: 0,
        top: 0,
        width: 669,
        height: 1148
      });
      //头像
      painting_view.push({
        type: "image",
        url: t.avatar,
        left: 34,
        top: 39,
        width: 68,
        height: 68,
        radius: 34
      });
      //昵称
      painting_view.push({
        type: "text",
        content: t.nickname,
        fontSize: 34,
        bolder: false,
        top: 52,
        left: 116,
        width: 490,
        lineHeight: 34,
        color: "#E0B8B3",
        breakWord: false,
        MaxLineNumber: 1
      });
      //祈福内容
      painting_view.push({
        type: "text",
        content: t.vowText,
        fontSize: 36,
        bolder: true,
        top: 131,
        left: 37,
        width: 550,
        lineHeight: 48,
        color: "#FFF0C6",
        textAlign: "left",
        breakWord: true,
        MaxLineNumber: 2
      });

      if (t.place && t.place.length > 6) {
        //祈福地址
        var add_top = 188;
        if (Vlen > 32) add_top += 48;
        painting_view.push({
          type: "image",
          url: t.addIcon,
          left: 34,
          top: add_top + 11,
          width: 18,
          height: 20
        });
        painting_view.push({
          type: "text",
          content: "我在",
          fontSize: 20,
          bolder: false,
          top: add_top + 8,
          left: 62,
          width: 60,
          lineHeight: 35,
          color: "#ffffff",
          textAlign: "left",
          breakWord: false,
          MaxLineNumber: 1
        });
        painting_view.push({
          type: "text",
          content: t.place,
          fontSize: 28,
          bolder: false,
          top: add_top,
          left: 62,
          width: 413,
          lineHeight: 35,
          color: "#ffffff",
          textAlign: "left",
          breakWord: true,
          MaxLineNumber: 2
        });
        var addend_left = 62 + (Plen % 34) * 14 + 8;
        if (Plen < 34)
          addend_left = 62 + (Plen - PPlen) * 14 + PPlen * 0.62 * 14 + 8;
        console.log("addend_left", addend_left);
        var addend_top = add_top + Math.floor(Plen / 34) * 35;
        painting_view.push({
          type: "text",
          content: "祈福",
          fontSize: 20,
          bolder: false,
          top: addend_top + 8,
          left: addend_left,
          width: 60,
          lineHeight: 35,
          color: "#ffffff",
          textAlign: "left",
          breakWord: false,
          MaxLineNumber: 1
        });
      }
      //二维码
      painting_view.push({
        type: "rect",
        backgroundColor: "#ffffff",
        left: 521,
        top: 891,
        width: 117,
        height: 116
      });
      painting_view.push({
        type: "qrcode",
        content: t.url,
        background: "#ffffff",
        color: "#000000",
        left: 528,
        top: 897,
        width: 104,
        height: 104
      });
      painting_view.push({
        type: "image",
        url: t.avatar,
        left: 528 + 104 / 2 - 22 / 2,
        top: 897 + 104 / 2 - 22 / 2,
        width: 22,
        height: 22,
        radius: 0
      });

      //祈福人数
      painting_view.push({
        type: "text",
        content: "已有",
        fontSize: 24,
        bolder: false,
        top: 1094,
        left: 29,
        width: 60,
        lineHeight: 35,
        color: "#FFF0C6",
        textAlign: "left",
        breakWord: false,
        MaxLineNumber: 1
      });
      painting_view.push({
        type: "text",
        content: t.zCount,
        fontSize: 46,
        bolder: true,
        top: 1074,
        left: 89,
        width: 500,
        lineHeight: 46,
        color: "#FAC137",
        textAlign: "left",
        breakWord: false,
        MaxLineNumber: 1
      });
      painting_view.push({
        type: "text",
        content: "人为武汉祈福",
        fontSize: 24,
        bolder: false,
        top: 1094,
        left: 89 + t.zCount.length * 25 + 15,
        width: 60,
        lineHeight: 35,
        color: "#FFF0C6",
        textAlign: "left",
        breakWord: false,
        MaxLineNumber: 1
      });

      var painting = {
        width: 669,
        height: 1148,
        views: painting_view
      };
      t.painting = painting;
    },
    //统计生成的海报
    addPosterId() {
      var t = this;
      var params = {
        poster_id: t.activeIndex + 1
      };
      t._get("user", "User.addPosterId", params)
        .then(res => {
          // t.closeVow();
          if (res.status == 0) {
            // t.iswin = 1;
            // t.myaward = res.data;
            // t.$router.push({
            //   path: "/shareindex",
            //   query: {
            //     vowtext: params.pray_str
            //   }
            // });
          } else {
            // if(res.status == 50005)用户未绑定手机号
            // typeof callback == "function" && callback(error);
            // if (res.status == 50008) {
            //   t.iswish = true;
            //   return false;
            // }
            // t.$toast(res.msg);
            // t.$router.push({
            //   path: "/shareindex",
            //   query: {
            //     vowtext: params.pray_str
            //   }
            // });
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
          t.$toast("请求错误");
        });
    },
    //初始化3d轮播图
    initSwiper() {
      this.$nextTick(async () => {
        await this.swiper.init(); // 现在才初始化
        await this.swiper.slideTo(0);
      });
    },
    getMyUser() {
      var t = this;
      if (!t.myUserInfo) {
        t._getUser(function() {
          t.user = t.myUserInfo;
        });
      } else {
        t.user = t.myUserInfo;
      }
    },
    goPoster() {
      var t = this;
      t._deepmain(t.pageId, "生成祈福海报", 2);
      t.addPosterId();
      if (t.urlData && t.urlData.vowtext) {
        if (t._getBrowser() == 1) {
          t.params = {
            vowtext:
              t.urlData.vowtext ||
              "# 武汉加油！我们一起打赢这场仗！中国加油！ #",
            place: t.urlData.place || "",
            zCount: t.wishTotal.toString(),
            postid: t.activeIndex + 1
          };
          t.getBaseUser();
        } else {
          t.$router.push({
            path: "/poster",
            query: {
              vowtext: encodeURIComponent(t.urlData.vowtext),
              place: t.urlData.place,
              postid: t.activeIndex + 1
            }
          });
        }
      } else {
        t.$toast("获取祝福语失败");
        t.$router.push({
          path: "/",
          query: {}
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../static/scss/shareindex.scss";
</style>
